/**
 * Get text from the passed in HTML.
 * @param html
 */
export function textFromHtml(html: string): string {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent ?? "";
}